import { StoneXModal } from "../../../../StoneXMui";
import { BudgetFilters } from "../Types";
import UpdateBudgets from "./UpdateBudgets";

interface UpdateBudgetsModalProps {
  budgetFilters: BudgetFilters;
  open: boolean;
  onClose: () => void;
  onSave: (budgetFilter: BudgetFilters) => void;
}

export function UpdateBudgetsModal(props: UpdateBudgetsModalProps) {
  const { budgetFilters, open, onClose, onSave} = props;

  return <StoneXModal width='95%' header='Update Budgets' open={open} onClose={onClose} sx={{maxWidth: '95%', maxHeight: '90%'}} height={'90%'}>
    <UpdateBudgets budgetFilters={budgetFilters} onSave={onSave} onClose={onClose} onCancel={onClose}/>
  </StoneXModal>
}